import { Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { HttpClient} from "@angular/common/http";
import { environment } from "src/environments/environment";
import { LearnerService } from '../services/learner.service';
import { PermissionService } from '../services/permission-service.service';
import { Toast, ToastrService } from 'ngx-toastr';
@Injectable({
    providedIn: 'root'
})
export class LoginService {

    baseUrl = environment.url;
    authUrl = 'appraisal/get_otp/';
    verifyOtpUrl = 'appraisal/verify_otp/';
    token: any;
    employeepermissions: any;
    empdata: any;
    returnUrl: any;

    constructor(
        private auth: AuthService,
        private http: HttpClient,
        private learnerService: LearnerService,
        private permissionService: PermissionService,
        private router: Router,
        private route: ActivatedRoute,
        private toastr:ToastrService
       ) {
    }

    accessToken(data:any) {
        localStorage.setItem('name', data.name);
        localStorage.setItem('userName', data.userName);
        const token = data.token;

        this.auth.getAccessToken(token).subscribe((res) => {
            if (res && res['token']) {
                const authToken = 'Token ' + res['token'];
                localStorage.setItem('accessToken', authToken);
                // Delay the employeeDetails call until token is fully stored
                    this.learnerService.getEmployeeDetails().subscribe({
                    next: (res: any) => {
                        this.employeepermissions = res['employee_permissions'];
                        this.empdata = res['data'];
                        console.log("All permissions: ", this.employeepermissions);
                        this.permissionService.setPermissions(this.employeepermissions);
                        this.permissionService.setEmployeeData(this.empdata);
                        this.returnUrl = this.route.snapshot.queryParamMap.get('returnUrl') || '/home';
                        this.router.navigateByUrl(this.returnUrl);
                    },
                    error: (err) => {
                         console.error('Failed to load permissions after login', err);
                         this.toastr.error('Failed to load user details.', 'Login Error');
                         this.router.navigate(['/login']);
                    }
                });
                
            } else {
                console.error('Token missing in response.');
                this.toastr.error('Token missing in response.','Login Failed');
            }
        });
    }


    logout() {
        localStorage.clear();
        sessionStorage.clear()
        this.router.navigate(['/login']);
    }

    isLoggedIn(): boolean {
        return localStorage.getItem('name') == null ? false : true;
    }

    getOtp(email: string) {
        const body = { email };
        return this.http.post(this.baseUrl + this.authUrl, body);
    }

    verifyOtp(email: string, otp: string) {
        const body = { email, otp };
        return this.http.post(this.baseUrl + this.verifyOtpUrl, body);
    }
     
}